import {FC} from "react";
import {Trans, useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader} from "@interstate/components/Card";
import "./SummaryCard.scss";

export interface SummaryCardProps {
  baseKey: string;
  qualifier?: string;
  count: number;
  name?: string;
}

export const SummaryCard: FC<SummaryCardProps> = ({
  baseKey,
  qualifier,
  count,
  name
}) => {
  const {t} = useTranslation();
  const labelKey = qualifier ? `${baseKey}.${qualifier}` : baseKey;
  return (
    <Card
      className={"create-hierarchy-summary-card"}
      data-testid={
        qualifier
          ? `create-hierarchy-${qualifier}-summary-card`
          : "create-hierarchy-summary-card"
      }
      header={
        <CardHeader
          title={t(`${labelKey}.title`, name ? {tenantName: name} : undefined)}
        />
      }
      content={
        <CardContent>
          <Trans
            i18nKey={`${labelKey}.content`}
            values={{count, name}}
            components={{bold: <strong className={"summary-card-count"} />}}
          />
        </CardContent>
      }
    />
  );
};
